<!--考级中心 我的社群 添加用户-->
<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-form
          :model="formData"
          ref="ruleForm"
          label-width="140px"
          class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
                label="用户选择"
            >
              <div v-if="formData.user.length > 0" style="cursor: pointer" @click="showUserPicker = true">{{ formData.user[0].name }}</div>
              <div v-else style="cursor: pointer" @click="showUserPicker = true">请选择用户 <i class="el-icon-arrow-right"></i></div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申报等级" prop="typeName">
              <el-radio-group v-model="formData.typeName">
                <el-radio :label="item" v-for="item in typeColumns">{{ item }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>


        <el-row>
          <el-col class="footer-button">
            <el-button
                type="primary"
                @click="submitForm('ruleForm')"
                :loading="saveLoading"
            >保存
            </el-button>
            <!--            <el-button @click="resetForm('ruleForm')" plain>重置</el-button>-->
          </el-col>
        </el-row>

        <UserPicker
            :show="showUserPicker"
            :limit="1"
            :defaultValue="formData.user"
            @onChange="onUserChange"
            @onClose="showUserPicker=false"
            @onConfirm="onUserConfirm"
        ></UserPicker>
      </el-form>
    </div>
  </div>
</template>
<style scoped>
.selected {
  color: #333;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}

.cell-img {
  width: 48px;
  height: 48px;
  float: left;
  border-radius: 50%;
  margin-right: 15px;
}


</style>
<script>
import Vue from 'vue';
import {
  Cell,
  Field,
  Area,
  DatetimePicker,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Dialog,
  Button,
  Calendar
} from 'vant';
import UserPicker from "../../../components/picker/UserPicker";

Vue.use(Cell).use(CellGroup).use(DatetimePicker).use(Calendar).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Dialog).use(Button);
export default {
  name: 'ClubDetailCommunityAdd',
  components: {
    UserPicker,
  },
  data: function () {
    return {
      showDate: false,
      showUserPicker: false,
      saveLoading: false,
      showPicker: false,

      formData: {
        user: [],
        typeName: '管理员',
        club_id: undefined,
        user_id: undefined,
        type: 2,
      },

      typeColumns: ['管理员', '教练员', '会员'],
      list: []
    }
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = "新增成员"
    that.formData.club_id = this.$route.query.id || 0;
  },
  watch: {},
  destroyed() {
  },
  methods: {
    onUserConfirm(values) {
      console.log('onUserConfirm', [...values])
      this.showUserPicker = false;
      this.formData.user = [...values];
    },

    onUserChange(values) {
      console.log('onUserChange', values)
      this.formData.user = [...values];
    },

    onConfirm(value) {
      console.log(value)
      let type = '';
      switch (value) {
        case '管理员':
          type = 2;
          break;
        case '教练员':
          type = 3;
          break;
        case '会员':
          type = 9;
          break;
      }

      this.formData.type = type
      this.formData.typeName = value
      this.showPicker = false;
    },

    submitForm(formName) {
      const that = this;
      // 拿到地区的 省市区名称
      // that.formData["area"] = that.formData.areas[2];

      console.log(that.formData, that.$refs[formName])
      that.$refs[formName].validate((valid) => {
        if (valid) {
          if (!that.formData.user.length) {
            this.$message.warning('请先选择用户')
            return
          }
          that.saveLoading = true;
          that.formData.user_id = that.formData.user[0].id

          that.$api.post('/api/club/clubUserAdd', that.formData, (res) => {
            that.saveLoading = false;
            that.$message.success('保存成功')
            rbLink({
              'name': 'ClubDetailCommunity',
            }, 'back')
          }, (res) => {
            that.$message.warning(res.msg);
            that.saveLoading = false;
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      if (!that.formData.user.length) {
        Toast('请先选择用户')
        return
      }

      that.saveLoading = true;
      that.formData.user_id = that.formData.user[0].id

      that.$api.post('/api/club/clubUserAdd', that.formData, (res) => {
        that.saveLoading = false;
        Toast.success('保存成功')
        rbLink({
          'name': 'ClubDetailCommunity',
        }, 'back')
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })


    },

  }
}
</script>



// WEBPACK FOOTER //
// ClubDetailCommunityAdd.vue?0c08e946